
/**
 * Clase que representa los filtros de consultas de magistrados con su lógica
 */
export default class FiltroExpedientes {
  numero: number;
  anio: number;
  
  
  constructor(numero?: number) {
      if (numero) this.numero = numero;

  }

  toQuerystring(): string {
    let query = (this.numero || this.anio) ? '&query=' : ''
    if(this.numero) query += `numero:${this.numero}${this.anio ? ',': ''}`
    if(this.anio) query += `anio:${this.anio}`
    return query
  }




}
